export const getComfortRanges = (
  riskProfiler: string,
  comfortRangeConfig: Record<string, string>,
  initialInvestments: any[]
): any[] => {
  if (riskProfiler === 'EValue') {
    return [];
  }

  return initialInvestments
    .filter(Boolean)
    .map(investment => {
      const bands: Record<string, number | null> = {};
      Object.keys(comfortRangeConfig).forEach(key => {
        bands[comfortRangeConfig[key]] =
          investment && investment[key]
            ? investment[key].high - Math.max(0, investment[key].low - 1)
            : null;
      });

      return {
        name: investment.name,
        growth_assets: investment?.growth_asset_percentage,
        ...bands
      };
    })
    .sort((a, b) => a.growth_assets - b.growth_assets);
};
